module.exports = __webpack_public_path__ + "img/icon_5_59.7f1b1ad0.png";